import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { LANGUAGE } from '@/utils/constant.utils';
import frCommon from '@/translations/locales/fr/common.json';
import frAuth from '@/translations/locales/fr/auth.json';
import frDashboard from '@/translations/locales/fr/dashboard.json';
import frEmailTemplate from '@/translations/locales/fr/emailTemplate.json';
import frCompany from '@/translations/locales/fr/company.json';
import frSideBard from '@/translations/locales/fr/sidebar.json';
import frGlobalEmailSetting from '@/translations/locales/fr/globalEmailSetting.json';
import frGroup from '@/translations/locales/fr/group.json';
import frVehicule from '@/translations/locales/fr/vehicule.json';
import frInspection from '@/translations/locales/fr/inspection.json';
import frRepairCosting from '@/translations/locales/fr/repairCosting.json';
import frRepairService from '@/translations/locales/fr/repairService.json';
import frRequestedAppUpdate from '@/translations/locales/fr/requestedAppUpdate.json';
import frBranch from '@/translations/locales/fr/branch.json';
import frUser from '@/translations/locales/fr/user.json';
import frCheckPoint from '@/translations/locales/fr/checkPoint.json';
import frEquipment from '@/translations/locales/fr/equipment.json';
import frDamage from '@/translations/locales/fr/damage.json';
import frInspectionType from '@/translations/locales/fr/inspectionType.json';
import frKpi from '@/translations/locales/fr/kpi.json';
import frEngineCorrection from '@/translations/locales/fr/engineCorrection.json';
import frEndpointHistory from '@/translations/locales/fr/endpointHistory.json';
import enCommon from '@/translations/locales/en/common.json';
import enCompany from '@/translations/locales/en/company.json';
import enAuth from '@/translations/locales/en/auth.json';
import enDashboard from '@/translations/locales/en/dashboard.json';
import enEmailTemplate from '@/translations/locales/en/emailTemplate.json';
import enSideBar from '@/translations/locales/en/sidebar.json';
import enGlobalEmailSetting from '@/translations/locales/en/globalEmailSetting.json';
import enGroup from '@/translations/locales/en/group.json';
import enVehicule from '@/translations/locales/en/vehicule.json';
import enInspection from '@/translations/locales/en/inspection.json';
import enBranch from '@/translations/locales/en/branch.json';
import enUser from '@/translations/locales/en/user.json';
import enCheckPoint from '@/translations/locales/en/checkPoint.json';
import enEquipment from '@/translations/locales/en/equipment.json';
import enDamage from '@/translations/locales/en/damage.json';
import enInspectionType from '@/translations/locales/en/inspectionType.json';
import enRepairCosting from '@/translations/locales/en/repairCosting.json';
import enRepairService from '@/translations/locales/en/repairService.json';
import enRequestedAppUpdate from '@/translations/locales/en/requestedAppUpdate.json';
import enKpi from '@/translations/locales/en/kpi.json';
import enEndpointHistory from '@/translations/locales/en/endpointHistory.json';
import enEngineCorrection from '@/translations/locales/en/engineCorrection.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    debug: true,
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      convertDetectedLanguage: (lng: string) => {
        // Extract language code before the dash
        const languageCode = lng.split('-')[0].toLowerCase();

        // Get supported languages in lowercase
        const supportedLanguages = LANGUAGE.map((lang) =>
          lang.lang.toLowerCase(),
        );

        // If language code exists in supported languages, return it, otherwise default to 'fr'
        return supportedLanguages.includes(languageCode) ? languageCode : 'fr';
      },
    },
    interpolation: {
      escapeValue: false,
    },
    ns: [
      'auth',
      'branch',
      'checkPoint',
      'common',
      'company',
      'damage',
      'dashboard',
      'emailTemplate',
      'endpointHistory',
      'engineCorrection',
      'equipment',
      'globalEmailSetting',
      'group',
      'inspection',
      'inspectionType',
      'kpi',
      'repairCosting',
      'repairService',
      'requestedAppUpdate',
      'sidebar',
      'user',
      'vehicule',
    ],
    defaultNS: 'common',
    resources: {
      fr: {
        auth: frAuth,
        branch: frBranch,
        checkPoint: frCheckPoint,
        common: frCommon,
        company: frCompany,
        damage: frDamage,
        dashboard: frDashboard,
        emailTemplate: frEmailTemplate,
        engineCorrection: frEngineCorrection,
        endpointHistory: frEndpointHistory,
        equipment: frEquipment,
        globalEmailSetting: frGlobalEmailSetting,
        group: frGroup,
        inspection: frInspection,
        inspectionType: frInspectionType,
        kpi: frKpi,
        repairCosting: frRepairCosting,
        repairService: frRepairService,
        requestedAppUpdate: frRequestedAppUpdate,
        sidebar: frSideBard,
        user: frUser,
        vehicule: frVehicule,
      },
      en: {
        auth: enAuth,
        branch: enBranch,
        checkPoint: enCheckPoint,
        common: enCommon,
        company: enCompany,
        damage: enDamage,
        dashboard: enDashboard,
        emailTemplate: enEmailTemplate,
        engineCorrection: enEngineCorrection,
        endpointHistory: enEndpointHistory,
        equipment: enEquipment,
        globalEmailSetting: enGlobalEmailSetting,
        group: enGroup,
        inspection: enInspection,
        inspectionType: enInspectionType,
        kpi: enKpi,
        repairCosting: enRepairCosting,
        repairService: enRepairService,
        requestedAppUpdate: enRequestedAppUpdate,
        sidebar: enSideBar,
        user: enUser,
        vehicule: enVehicule,
      },
    },
  });

export default i18n;
